import React, { useContext, useState } from "react";

import {
  ActivitiesMajor,
  AddProductMajor,
  CustomerPlusMajor,
  CollectionsMajor,
  ChatMajor,
} from "@shopify/polaris-icons";

import { PlanCard } from "app/plans";
import { QuickLink, QuickReport } from "app/reports";
import { TwoColumnLayout } from "layout/private/components";
import { PrivateContext } from "lib/context";
import { Banner, SkeletonList, Toast } from "lib/components";

import { Activity } from "app/userManagement/modules";
import { withErrorBoundary } from "lib/hoc";

import OperatorExportReporting from "app/dashboard/modules/operator/export/export";
import ApiAccess from "./apiAccess/apiAccess";

const OperatorDashboard = () => {
  const { isLoading, cms = {}, currentUser } = useContext(PrivateContext);
  const { ecommercePlatform, plan: { price = 0 } = {} } = currentUser;
  const [isExportModal, setIsExportModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [banner, setBanner] = useState({
    isOpen: false,
    status: "",
    title: "",
  });

  const apiAccessPricePlan = [899, 1299];

  const handleShow = () => {
    setIsExportModal(true);
  };

  // eslint-disable-next-line consistent-return
  const getSecondaryComponent = () => {
    if (cms) {
      const linkData = [
        {
          caption: cms("common.actions.dashboard.caption.activity"),
          label: cms("common.actions.dashboard.label.activity"),
          link: "/activity",
          icon: ActivitiesMajor,
        },
        {
          caption: cms("common.actions.dashboard.caption.addProducts"),
          label: cms("common.actions.dashboard.label.addProducts"),
          link: ecommercePlatform ? "/product-lake/add" : "/products/add",
          icon: AddProductMajor,
        },
        {
          caption: cms("common.actions.dashboard.caption.addVendors"),
          label: cms("common.actions.dashboard.label.addVendors"),
          link: "/providers/add",
          icon: CustomerPlusMajor,
        },
        {
          caption: cms("common.actions.dashboard.caption.contactUs"),
          label: cms("common.actions.dashboard.label.contactUs"),
          link: "/contact-us",
          icon: ChatMajor,
        },
        {
          onClick: handleShow,
          caption: cms("common.actions.dashboard.caption.report"),
          id: "exportOrder",
          label: cms("common.actions.dashboard.label.report"),
          icon: CollectionsMajor,
        },
      ];
      return (
        <>
          {!ecommercePlatform && apiAccessPricePlan.includes(price) && (
            <ApiAccess
              apiAccessPricePlan={apiAccessPricePlan}
              price={price}
              setBanner={setBanner}
              setSuccessMessage={setSuccessMessage}
            />
          )}
          <PlanCard />
          <QuickLink link={linkData} />
          <QuickReport />
        </>
      );
    }
  };
  const closeBanner = () => {
    setBanner({
      isOpen: false,
      status: "",
      title: "",
    });
  };

  const getComponent = () => {
    if (isLoading && !price) {
      return <SkeletonList />;
    }
    return (
      <>
        {banner.isOpen && (
          <>
            <Banner
              isOpen={banner.isOpen}
              status={banner.status}
              title={banner.title}
              onDismiss={() => closeBanner()}
            />
            <br />
          </>
        )}
        <Activity />
        <OperatorExportReporting isOpenModal={isExportModal} setIsOpenModal={setIsExportModal} />
        <Toast message={successMessage} />
      </>
    );
  };
  return <TwoColumnLayout primary={getComponent()} secondary={getSecondaryComponent()} />;
};

export default withErrorBoundary(OperatorDashboard);
